
import React from 'react';
import ReaderOnboarding from '@/components/onboarding/reader/ReaderOnboarding';

const ReaderOnboardingPage: React.FC = () => {
  return <ReaderOnboarding />;
};

export default ReaderOnboardingPage;
